import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useAuthState, authActionType, useAuthDispatch } from '@/plugins/Auth';
import { useProfileStoreContext } from '../contexts/profile';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import Profile from '../components/Profile';
import useGlobalModalContext from '../../hooks/useGlobalModalContext';
import { getUserProfile } from '../../register/api/auth';

export default () => {
  const [isUserProfileLoading, setIsUserProfileLoading] = useState(true);
  const {
    isLoading: isProfileLoading, profile, getProfile, saveProfile, isInited,
  } = useProfileStoreContext();
  const { openModal } = useGlobalModalContext();
  const { user, token } = useAuthState();
  const hasUserVerifiedEnterpriseCard = useMemo(() => !!_.get(user, ['enterpriseCardVerified'], null), [user]);
  const verifyingEnterpriseCardExpireTime = useMemo(() => _.get(user, ['verifyingEnterpriseCardExpireTime'], null), [user]);
  const authDispatch = useAuthDispatch();
  const reload = async () => {
    if (!token) return;
    getProfile();
    setIsUserProfileLoading(true);
    try {
      const userProfileReseult = await getUserProfile(token);
      const {
        data: userProfile,
        status: getUserProfileStatus,
      } = userProfileReseult || {};
      if (getUserProfileStatus === 'success') {
        authDispatch({
          type: authActionType.LOGIN_SUCCESS,
          payload: {
            token,
            user: {
              ...userProfile,
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
    setIsUserProfileLoading(false);
  };
  useEffect(() => {
    reload();
  }, [ ]); //eslint-disable-line

  const onSaveButtionClick = async (values) => {
    const {
      gender, year, month, day, email, mobileBarcode,
    } = values;
    const { status, message } = await saveProfile({
      birthday: [year, month, day],
      gender,
      email,
      mobileBarcode: (mobileBarcode || '').toUpperCase(),
    });
    if (status !== 'success') {
      openModal({
        title: '資料更新失敗',
        content: message || '資料更新失敗',
      });
      return false;
    }
    return true;
  };

  if ((isProfileLoading || isUserProfileLoading) && !isInited) return <ProgressBackdrop isShow />;

  return (
    <Profile
      hasUserVerifiedEnterpriseCard={hasUserVerifiedEnterpriseCard}
      verifyingEnterpriseCardExpireTime={verifyingEnterpriseCardExpireTime}
      data={profile}
      reload={reload}
      isLoading={isUserProfileLoading || isProfileLoading}
      onSaveButtionClick={onSaveButtionClick}
    />
  );
};
